import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { ConsoleApi } from './console-api.js';
import type { MetaSignupClient } from './meta-signup.js';

/**
 * Services constructed at the composition root and injected — not looked up at module scope.
 * They are nullable because the console renders (signed out, or with the Meta app unprovisioned)
 * before either exists. See ADR 0001 and ADR 0005.
 */
export interface ConsoleServices {
  api: ConsoleApi | null;
  signup: MetaSignupClient | null;
  googleMapsApiKey: string | null;
}

const ConsoleServicesContext = createContext<ConsoleServices>({
  api: null,
  signup: null,
  googleMapsApiKey: null,
});

export function ConsoleServicesProvider({
  value,
  children,
}: {
  value: ConsoleServices;
  children: ReactNode;
}) {
  return (
    <ConsoleServicesContext.Provider value={value}>{children}</ConsoleServicesContext.Provider>
  );
}

export function useConsoleServices(): ConsoleServices {
  return useContext(ConsoleServicesContext);
}
